import { render } from "./VehicleMiniLink.vue?vue&type=template&id=78a8c08a&scoped=true"
import script from "./VehicleMiniLink.vue?vue&type=script&lang=js"
export * from "./VehicleMiniLink.vue?vue&type=script&lang=js"

import "./VehicleMiniLink.vue?vue&type=style&index=0&id=78a8c08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a8c08a"]])

export default __exports__